
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";
import Layout from "@/components/Layout";

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [hasSeenLanding] = useState<boolean>(() => {
    return localStorage.getItem("hasSeenLanding") === "true";
  });

  console.log("Index - User:", user?.email, "Loading:", loading, "HasSeenLanding:", hasSeenLanding);

  useEffect(() => {
    // Don't redirect if still loading
    if (loading) return;

    // Use requestAnimationFrame to ensure DOM is ready before navigation
    const handleNavigation = () => {
      // Mark that they've seen the landing page
      localStorage.setItem("hasSeenLanding", "true");
      
      if (user) {
        console.log("Index - User authenticated, redirecting to dashboard");
        navigate('/dashboard', { replace: true });
      } else if (hasSeenLanding) {
        console.log("Index - User has seen landing page, redirecting to auth");
        navigate('/auth', { replace: true });
      } else {
        console.log("First time visitor, showing landing page");
        navigate('/landing', { replace: true });
      }
    };

    // Small delay to ensure rendering is complete
    requestAnimationFrame(handleNavigation);
  }, [user, loading, hasSeenLanding, navigate]);

  // Show minimal loading state
  return (
    <Layout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900 mx-auto mb-2"></div>
          <p className="text-sm">Loading...</p>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
